<template>
	<div class="debtorPaymentDetail">
		<div class="payment_title">
			<h4 class="font_bold">{{ $t("trackPay.debtorPaymentDetail.title") }}</h4>
		</div>
		<div class="text_left tertiary_color">
			{{ $t("trackPay.debtorPaymentDetail.titleTip") }}
		</div>
		<div class="payment_content">
			<div v-for="(item, index) in paymentList" :key="index" class="flex" style="text-indent: 20px;">
				<p class="payment_label tertiary_color">{{ $t(item.label) }}：</p>
				<p class="font_bold font_base">{{ paymentData[item.valueKey][paymentData.currency] || paymentData[item.valueKey] }}</p>
			</div>
		</div>
		<div v-if="contractData.status === 20" class="flex flex_between margin_top">
			<md-button class="md-blank" @click="back">{{ $t("common.button.back") }}</md-button>
			<div>
				<md-button @click="reject" class="md-block margin_r"
				>{{ $t("trackPay.debtorContractAction.reject") }}
				</md-button>

				<md-button @click="confirm" class="md-primary"
				>{{ $t("common.confirm") }}
				</md-button>
			</div>
		</div>
		<div v-else class="flex flex_between">
			<div></div>
			<md-button class="md-blank" @click="close">{{
					$t("common.button.close")
				}}</md-button>
		</div>
		<RejectModal
			@success="success"
			ref="rejectModal"
			:contractData="contractData"
		></RejectModal>
	</div>
</template>
<script>
import RejectModal from "@/components/templates/trackPay/debtor/RejectModal";
import {formatAsMoneyAmount} from "@/common/format";
import {trackPayApi} from "@/common/api/trackPayApi";

export default {
	components: {
		RejectModal,
	},
	props: {
		readOnly: Boolean,
		contractData: Object,
	},
	mounted() {
		trackPayApi.debtor.getBankAccountsForPayment()
			.then((res) => {
				res.map(r => {
					if (r.tbCurrType == "EUR") {
						this.paymentData.iban.EUR = r.tbIban;
						this.paymentData.bic.EUR = r.bic;
					} else {
						this.paymentData.iban.USD = r.tbIban;
						this.paymentData.bic.USD = r.bic;
					}
				});

			});
	},
	data() {
		return {
			paymentData: {
				receiver: this.contractData.supplier.name + " via TNP",
				iban: { EUR: "", USD: "" },
				bic: { EUR: "", USD: "" },
				amount: formatAsMoneyAmount(this.contractData.amount, null),
				currency: this.contractData.currency,
				purpose: "Settle invoice no: " + this.contractData.invoiceNumber + " by " + this.contractData.debtor.name,
			},
			paymentList: [
				{
					label: "PayImgInfo.Receiver",
					valueKey: "receiver",
				},
				{
					label: "common.iban",
					valueKey: "iban",
				},
				{
					label: "common.bic",
					valueKey: "bic",
				},
				{
					label: "common.amount",
					valueKey: "amount",
				},
				{
					label: "common.currency",
					valueKey: "currency",
				},
				{
					label: "trackPay.debtorContractModal.purpose",
					valueKey: "purpose",
				},
			],
		};
	},
	methods: {
		back() {
			this.$emit("back");
		},
		close() {
			this.$emit("close");
		},
		reject() {
			this.$refs.rejectModal.showDetail();
		},
		confirm() {
			this.$emit("confirm", "confirm");
		},
		success() {
			this.$emit("success");
		},
	},
};
</script>
<style lang="scss" scoped>
.debtorPaymentDetail {
	width: 790px;
	margin: auto;
	.payment_title {
		margin: 40px auto 60px;
	}
	.payment_content {
		width: 780px;
		padding: 20px;
		background-color: #cbe9fe;
		margin: 30px auto;
		p {
			margin-bottom: 0px;
		}
	}
	.payment_label {
		width: 160px;
		text-align: right;
		color: #5f6164;
	}
}
</style>
